import { gatewayInstance } from "../axiosInstance";

export const getRequestStatusSummary = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/analyticalservice/dashboard-data/request-status-summary`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getLiveRequestSummaryData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/analyticalservice/dashboard-data/request-summary-data`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getVehicleTypeData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/analyticalservice/dashboard-data/vehicle-type`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getTotalAssignments = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/analyticalservice/dashboard-data/total-assignments`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getShipperWiseJobs = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/analyticalservice/dashboard-data/shipper-wise-jobs`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
export const getPlacementAndBookings = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/analyticalservice/dashboard-data/bookings`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

